import React, { useState, useEffect, useRef } from 'react'
import { getNeseniai } from '../utils/neseniai'

// Mažosios raidės be lietuviškų diakritikų (paieškai)
function normalizuoti(s) {
  return (s || '').toString().toLowerCase()
    .replace(/ą/g, 'a').replace(/č/g, 'c').replace(/ę/g, 'e').replace(/ė/g, 'e')
    .replace(/į/g, 'i').replace(/š/g, 's').replace(/ų/g, 'u').replace(/ū/g, 'u').replace(/ž/g, 'z')
}

function VietosEilute({ vieta, onClick }) {
  const nuotr = vieta.nuotraukos?.[0] || vieta.nuotrauka_url
  return (
    <div
      onClick={() => setTimeout(() => onClick(vieta), 140)}
      onPointerDown={(e) => { e.currentTarget.style.transform = 'scale(0.98)'; e.currentTarget.style.background = 'rgba(240,232,213,0.05)' }}
      onPointerUp={(e) => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.background = 'transparent' }}
      onPointerLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.background = 'transparent' }}
      style={{ display: 'flex', gap: '12px', alignItems: 'center', padding: '9px 8px', margin: '0 -4px', borderBottom: '1px solid #2A3B32', cursor: 'pointer', transition: 'transform 0.14s ease, background 0.14s ease' }}
    >
      <div style={{ width: '52px', height: '52px', borderRadius: '8px', overflow: 'hidden', background: '#1E2E27', flexShrink: 0 }}>
        {nuotr && <img src={nuotr} alt={vieta.pavadinimas} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
      </div>
      <div style={{ minWidth: 0 }}>
        <p style={{ color: '#F0E8D5', fontSize: '14px', fontFamily: "'Lora', Georgia, serif", margin: 0, lineHeight: 1.2 }}>{vieta.pavadinimas}</p>
        <p style={{ color: '#7A8A7E', fontSize: '11px', margin: '3px 0 0' }}>{[vieta.miestas, vieta.kategorija].filter(Boolean).join(' · ')}</p>
      </div>
    </div>
  )
}

function PaieskaEkranas({ atidaryta, onClose, vietos, onVietaPasirinkta, onRodytiZemelapyje }) {
  const [q, setQ] = useState('')
  const [neseniai, setNeseniai] = useState([])
  const inputRef = useRef(null)

  useEffect(() => {
    if (atidaryta) {
      setQ('')
      setNeseniai(getNeseniai())
      const t = setTimeout(() => inputRef.current && inputRef.current.focus(), 120)
      return () => clearTimeout(t)
    }
  }, [atidaryta])

  const aktyvi = q.trim().length > 0
  const rezultatai = aktyvi
    ? (() => {
        const n = normalizuoti(q)
        return vietos
          .filter(v =>
            normalizuoti(v.pavadinimas).includes(n) ||
            normalizuoti(v.miestas).includes(n) ||
            normalizuoti(v.kategorija).includes(n) ||
            normalizuoti(v.regionas).includes(n) ||
            normalizuoti(v.aprasymas).includes(n)
          )
          .slice(0, 60)
      })()
    : []

  function rodytiZemelapyje() {
    if (rezultatai.length > 0 && onRodytiZemelapyje) onRodytiZemelapyje(rezultatai, q.trim())
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: '#141F1A', zIndex: 1003, transform: atidaryta ? 'translateY(0)' : 'translateY(100%)', transition: 'transform 320ms cubic-bezier(0.32,0.72,0,1)', display: 'flex', flexDirection: 'column' }}>

      {/* Header su paieškos lauku */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: 'calc(12px + env(safe-area-inset-top)) 16px 12px', borderBottom: '1px solid #2A3B32' }}>
        <button onClick={onClose} aria-label="Atgal" style={{ width: '36px', height: '36px', borderRadius: '50%', background: 'transparent', border: '1px solid #3A4C42', color: '#F0E8D5', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, cursor: 'pointer' }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
        </button>
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '10px', padding: '0 14px', height: '44px', background: '#1E2E27', border: '1px solid #2A3B32', borderRadius: '10px' }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" strokeWidth="1.85" stroke="#7A8A7E" strokeLinecap="round">
            <circle cx="10.5" cy="10.5" r="7" /><path d="M15.8 15.8l5 5" />
          </svg>
          <input
            ref={inputRef}
            value={q}
            onChange={e => setQ(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter') rodytiZemelapyje() }}
            enterKeyHint="search"
            placeholder="Ieškoti vietos, miesto ar žodžio…"
            style={{ flex: 1, minWidth: 0, background: 'transparent', border: 'none', outline: 'none', color: '#F0E8D5', fontSize: '14px', fontFamily: 'Syne, system-ui, sans-serif' }}
          />
          {aktyvi && (
            <button onClick={() => { setQ(''); inputRef.current && inputRef.current.focus() }} aria-label="Išvalyti" style={{ background: 'transparent', border: 'none', color: '#7A8A7E', cursor: 'pointer', padding: 0, display: 'flex' }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round"><path d="M18 6L6 18M6 6l12 12" /></svg>
            </button>
          )}
        </div>
      </div>

      {/* Turinys */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '4px 16px 24px' }}>
        {aktyvi ? (
          rezultatai.length === 0 ? (
            <p style={{ color: '#7A8A7E', fontSize: '13px', textAlign: 'center', padding: '28px 0', margin: 0 }}>Nieko nerasta pagal „{q}"</p>
          ) : (
            rezultatai.map(v => <VietosEilute key={v.id} vieta={v} onClick={onVietaPasirinkta} />)
          )
        ) : neseniai.length > 0 ? (
          <>
            <div style={{ color: '#7A8A7E', fontSize: '10px', letterSpacing: '0.1em', textTransform: 'uppercase', margin: '12px 4px 6px' }}>Neseniai</div>
            {neseniai.map(v => <VietosEilute key={v.id} vieta={v} onClick={onVietaPasirinkta} />)}
          </>
        ) : (
          <p style={{ color: '#7A8A7E', fontSize: '13px', textAlign: 'center', padding: '40px 20px', lineHeight: 1.5, margin: 0 }}>
            Ieškok vietos pagal pavadinimą ar miestą.<br />Čia rodysis ir neseniai atidarytos vietos.
          </p>
        )}
      </div>
    </div>
  )
}

export default PaieskaEkranas
